import React from 'react'

const TextDetail = ( { label, val, color = "#000" } ) => {
  return (
    <div className="flex flex-row items-center my-1" style={{ fontSize: ".75rem"}}>
        <span className="mx-2 font-bold">{`${label}:`}</span>
        <span style={{ color }}>{val}</span>
    </div>
  )
}

export default TextDetail